//TODO: use lazy loading: https://alligator.io/vuejs/lazy-loading-vue-cli-3-webpack/
import Form from '@/views/Form.vue'
//Auth Views
//import Login from '@/views/auth/Login.vue'
import Gdpr from '@/views/GDPR.vue'
import Vote from '@/views/Vote.vue'
import DisabledForm from '@/views/Disabled.vue'

const routes = [
    {
        path: '/:editId?',
        name: 'form',
        component: DisabledForm
    },
    {
        path: '/editor/:editId?',
        name: 'form',
        component: Form
    },
    //Auth views
    {
        path: '/gdpr',
        name: 'gdpr',
        component: Gdpr
    },
    //Voting
    {
        path: '/vote',
        name: 'vote',
        component: Vote
    },
]

export default routes;
